<div class="modal-header">
  <h3 class="modal-title">BEPS Quarters</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times"></i>
  </div>
</div>

<form [formGroup]="quartersForm" novalidate>
  <div class="modal-body">
    <div class="form-group">
      <label for="tax-year">Tax Year</label>
      <select class="form-control" id="tax-year" formControlName="TAX_YEAR" required>
        @for (taxYear of taxYears; track $index) {
          <option [value]="taxYear.label">{{ taxYear.label }}</option>
        }
      </select>
    </div>

    <div class="form-group">
      <label for="quarter">Quarter</label>
      <select class="form-control" id="quarter" formControlName="QUARTER" required>
        <option [value]="1">1</option>
        <option [value]="2">2</option>
        <option [value]="3">3</option>
        <option [value]="4">4</option>
      </select>
    </div>

    <div class="form-group checkbox-row">
      <label for="active">Active</label>
      <input type="checkbox" formControlName="ACTIVE" id="active">
    </div>
  </div>

  <div class="modal-footer">
    <ap-button [btnType]="'primary'" [label]="'Submit'" [disabled]="quartersForm.invalid" (onClick)="onSubmit()"></ap-button>
  </div>
</form>
